import { Link } from 'react-router-dom';
import { topPlatforms } from '@/mocks/platforms';

export default function PlatformGrid() {
  const platformImages: Record<number, string> = {
    1: "https://readdy.ai/api/search-image?query=Modern%20clean%20streaming%20platform%20interface%20mockup%20on%20a%20laptop%20screen%20with%20movie%20thumbnails%2C%20warm%20coral%20accent%20colors%2C%20minimalist%20UI%20design%2C%20soft%20ambient%20lighting%2C%20professional%20product%20photography%2C%20simple%20background&width=800&height=500&seq=platform-card-01&orientation=landscape",
    2: "https://readdy.ai/api/search-image?query=Modern%20video%20streaming%20app%20interface%20on%20tablet%20device%20with%20movie%20posters%20grid%2C%20warm%20yellow%20amber%20accent%20colors%2C%20minimalist%20design%2C%20clean%20simple%20background%2C%20professional%20product%20photography&width=800&height=500&seq=platform-card-02&orientation=landscape",
    3: "https://readdy.ai/api/search-image?query=Modern%20video%20platform%20interface%20on%20smartphone%20showing%20drama%20series%20list%2C%20warm%20red%20accent%20colors%2C%20minimalist%20UI%20design%2C%20clean%20simple%20background%2C%20professional%20product%20photography&width=800&height=500&seq=platform-card-03&orientation=landscape",
    4: "https://readdy.ai/api/search-image?query=Modern%20anime%20streaming%20platform%20interface%20on%20laptop%20screen%20with%20colorful%20anime%20thumbnails%2C%20warm%20pink%20accent%20colors%2C%20minimalist%20UI%20design%2C%20clean%20simple%20background%2C%20professional%20product%20photography&width=800&height=500&seq=platform-card-04&orientation=landscape",
    5: "https://readdy.ai/api/search-image?query=Modern%20short%20video%20app%20interface%20on%20smartphone%20in%20vertical%20orientation%2C%20warm%20orange%20accent%20colors%2C%20minimalist%20design%2C%20clean%20simple%20background%2C%20professional%20product%20photography&width=800&height=500&seq=platform-card-05&orientation=landscape",
  };

  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
            精选推荐平台
          </h2>
          <p className="text-base text-foreground-600 max-w-2xl mx-auto">
            经过严格评测筛选，为您推荐以下五大优质视频平台，每个平台都有独特的优势与特色
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-product-shop>
          {topPlatforms.map((platform) => (
            <Link
              key={platform.id}
              to={`/category/all`}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={platformImages[platform.id]}
                  alt={platform.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={`${platform.name} - 高清免费在线观看视频平台`}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-background-50/90 text-foreground-800 whitespace-nowrap">
                    {platform.category}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="flex items-center gap-1 px-2 py-1 rounded-full text-xs font-bold bg-accent-500 text-background-50 whitespace-nowrap">
                    <i className="ri-star-fill text-xs"></i>
                    {platform.rating}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {platform.name}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                  {platform.description}
                </p>
                <div className="flex flex-wrap gap-1.5">
                  {platform.features.slice(0, 3).map((f) => (
                    <span
                      key={f}
                      className="px-2 py-0.5 rounded-md text-xs bg-secondary-100 text-secondary-700 whitespace-nowrap"
                    >
                      {f}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/all"
            className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-full bg-secondary-500 text-background-50 text-sm font-medium hover:bg-secondary-600 transition-colors cursor-pointer"
          >
            查看全部平台
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}